import Joi from "joi"

export const campusPlacementData = [
    "Indian Institute of Management- Ahmedabad",
    "Indian Institute of Management- Calcutta",
    "Indian Institute of Management- Indore",
    "Institute of Management Technology- Ghaziabad",
    "MICA - Ahmedabad",
    "NMIMS - Mumbai",
    "Symbiosis Institute of Business Management - Pune",
    "Xavier Institute of Management (XIMB)",
    "Indian Institute of Technology - Delhi",
    "Indian Institute of Technology - Kanpur",
    "Indian Institute of Technology - Kharagpur",
    "Lady Shri Ram College",
    "Shri Ram College of Commerce",
    "St. Xaviers College"
]


export const RECRUITMENT_FORM_FIELD_KEYS = {
    EMAIL: 'email',
    COLLEGE : 'college',
}

const emailRegex = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/

export const lateralHiringSchema = Joi.object({
    [RECRUITMENT_FORM_FIELD_KEYS.EMAIL]: Joi.string().label("E-Mail").email({ tlds: { allow: false } }).required().trim().regex(emailRegex).messages({
        "string.pattern.base": "\"E-Mail\" not valid"
    }),
})

export const campusPlacementSchema = Joi.object({
    [RECRUITMENT_FORM_FIELD_KEYS.EMAIL]: Joi.string().label("E-Mail").email({ tlds: { allow: false } }).required().trim().regex(emailRegex).messages({
        "string.pattern.base": "\"E-Mail\" not valid"
    }),
    [RECRUITMENT_FORM_FIELD_KEYS.COLLEGE]: Joi.string().label("College").required().messages({
        "string.pattern.base": "\"Please select a college\""
    })
})